
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 7.5V6h-9C.673 6 0 6.673 0 7.5v3h10.816a13.43 13.43 0 01-.316-3zM23.939 13.5c-1.023 1.576-2.584 2.917-4.819 4.201a2.258 2.258 0 01-2.236.003c-2.235-1.287-3.795-2.63-4.82-4.204H0V21c0 .828.673 1.5 1.5 1.5h21A1.5 1.5 0 0024 21v-7.5h-.061zM6.75 18h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5z","fill":"#838383"}}),_c('path',{attrs:{"d":"M23.546 3.811l-5.25-2.25a.753.753 0 00-.593 0l-5.25 2.25A.748.748 0 0012 4.5v3c0 4.126 1.525 6.538 5.627 8.9a.753.753 0 00.747 0C22.474 14.045 24 11.633 24 7.5v-3c0-.3-.178-.572-.454-.689zm-2.71 3.408l-3 3.75a.758.758 0 01-.586.28h-.032a.753.753 0 01-.592-.332l-1.5-2.25a.75.75 0 111.248-.831l.931 1.396 2.358-2.949a.75.75 0 011.173.936z","fill":"#838383"}})])
          )
        }
      }
    